var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 102,
    viewBox: "0 0 224 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_868_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7499 13.8848C38.6717 13.8848 28.0472 18.2856 20.2138 26.119C12.3803 33.9525 7.97949 44.5769 7.97949 55.6551L7.97949 146.158C7.97949 157.236 12.3803 167.86 20.2138 175.694C28.0472 183.527 38.6717 187.928 49.7499 187.928H175.061C186.139 187.928 196.764 183.527 204.597 175.694C212.431 167.86 216.831 157.236 216.831 146.158V76.5403C216.831 65.4621 212.431 54.8377 204.597 47.0042C196.764 39.1707 186.139 34.77 175.061 34.77L105.444 34.77L96.7972 26.1235C92.9177 22.2428 88.3116 19.1646 83.2421 17.0646C78.1725 14.9646 72.7389 13.8841 67.2516 13.8848L49.7499 13.8848ZM67.1542 83.502C64.3846 83.502 61.7285 84.6022 59.7702 86.5606C57.8118 88.519 56.7116 91.1751 56.7116 93.9446C56.7116 96.7142 57.8118 99.3703 59.7702 101.329C61.7285 103.287 64.3846 104.387 67.1542 104.387L157.657 104.387C160.426 104.387 163.082 103.287 165.041 101.329C166.999 99.3703 168.099 96.7142 168.099 93.9446C168.099 91.1751 166.999 88.519 165.041 86.5606C163.082 84.6022 160.426 83.502 157.657 83.502L67.1542 83.502Z",
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 35.1657L105.212 35.3297H105.444L175.061 35.3297C185.991 35.3297 196.473 39.6715 204.201 47.4C211.93 55.1285 216.272 65.6106 216.272 76.5403V146.158C216.272 157.087 211.93 167.569 204.201 175.298C196.473 183.026 185.991 187.368 175.061 187.368H49.7499C38.8201 187.368 28.338 183.026 20.6095 175.298C12.8811 167.569 8.53923 157.087 8.53923 146.158L8.53923 55.6551C8.53923 44.7254 12.8811 34.2433 20.6095 26.5148C28.338 18.7863 38.8201 14.4445 49.7499 14.4445L67.2516 14.4445H67.2517C72.6655 14.4439 78.0263 15.5099 83.0279 17.5817C88.0295 19.6535 92.5739 22.6906 96.4014 26.5192L96.4014 26.5193L105.048 35.1657ZM67.1542 82.9423C64.2362 82.9423 61.4377 84.1015 59.3744 86.1648C57.311 88.2281 56.1519 91.0266 56.1519 93.9446C56.1519 96.8626 57.311 99.6611 59.3744 101.724C61.4377 103.788 64.2362 104.947 67.1542 104.947L157.657 104.947C160.575 104.947 163.373 103.788 165.436 101.724C167.5 99.6611 168.659 96.8626 168.659 93.9446C168.659 91.0266 167.5 88.2281 165.436 86.1648C163.373 84.1015 160.575 82.9423 157.657 82.9423L67.1542 82.9423Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 1.11947,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_868_4376",
    x: -5.4542,
    y: 0.451078,
    width: 235.719,
    height: 200.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.71684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_868_4376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_868_4376",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.9d95a8218154866d8b516545439e9e3d.svg";
export { ForwardRef as ReactComponent };